module.exports = __webpack_public_path__ + "img/1_007.cd8e54ff.jpg";